module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer"
  }, [(_vm.trayType === 'Chat') ? _c('div', {
    staticClass: "chat-header-arrow"
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Chat') ? _c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "title chatTitle"
  }, [_vm._v(_vm._s(_vm.trayType))]), _vm._v(" "), _c('a', {
    staticClass: "btn-right",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _c('div', {
    staticClass: "tray-header"
  }, [(_vm.trayType === 'Questions') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": require("../assets/icons/questions_selected.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'People') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": require("../assets/icons/people_selected.svg")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Sessions') ? _c('img', {
    staticClass: "header-icon",
    attrs: {
      "src": require("../assets/icons/sessions_selected.svg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.trayType))]), _vm._v(" "), (_vm.presentation) ? _c('a', {
    staticClass: "btn-right",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()]), _vm._v(" "), (_vm.trayType === 'Sessions') ? _c('sessionstray', {
    attrs: {
      "presentations": _vm.presentationList,
      "isLoading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Questions') ? _c('questiontray', {
    attrs: {
      "peopleMap": _vm.peopleMap,
      "questions": _vm.questionList,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'People') ? _c('peopletray', {
    attrs: {
      "people": _vm.peopleList,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.trayType === 'Chat') ? _c('chattray', {
    attrs: {
      "presentation": _vm.presentation,
      "person": _vm.person,
      "user": _vm.user,
      "contacts": _vm.chatContacts,
      "chatList": _vm.chatList,
      "peopleMap": _vm.peopleMap
    },
    on: {
      "updateChat": function($event) {
        _vm.updateChat($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47040469","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomTray.vue
// module id = 471
// module chunks = 0